import { Box, Grid, Typography } from '@mui/material';
import { BoxProps } from '@mui/system';
import { map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { State } from 'src/common/store';
import { Icons } from 'src/components/icons';
import { Loader } from 'src/components/loader';
import { ROUTES } from 'src/constants/routes';
import { getNews } from 'src/thunks/news-thunk';
import { NewsCard } from '../news-card';
import useStyles from './styles';

interface NewsBlockProps {
  title?: string;
  showItems: number;
  loadMoreBtn?: boolean;
  allNewsLink?: boolean;
}

export const NewsBlock: ComponentType<NewsBlockProps & BoxProps> = ({
  title,
  showItems,
  loadMoreBtn,
  allNewsLink,
  ...boxProps
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNews({ take: showItems, language: i18n.language, embed: 'cover' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const { isLoading, data } = useSelector((state: State) => state.news.list);

  if (isLoading) return <Loader />;

  return (
    <Box className={classes.root} {...boxProps}>
      {title && (
        <Typography variant="h1" component="h2" mb={5}>
          {title}
        </Typography>
      )}
      <Grid container spacing={4}>
        {map(data, (item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <NewsCard item={item} />
          </Grid>
        ))}
        {allNewsLink && (
          <Grid item textAlign="center" xs={12} hidden={!data || data.length < showItems}>
            <Typography
              variant="subtitle2"
              component={Link}
              to={ROUTES.NEWS.ROOT}
              className={classes.allNewsLink}
              color="secondary"
              mt={6.25}
            >
              {t('allNews', 'Все новости')}
              <Icons.ArrowLeft />
            </Typography>
          </Grid>
        )}
        {/* {loadMoreBtn && (
          <Grid item textAlign="center" xs={12}>
            <LoadingButton variant="outlined" size="large" color="secondary" sx={{ mt: 6 }}>
              {t('showMore', 'Показать больше')}
            </LoadingButton>
          </Grid>
        )} */}
      </Grid>
    </Box>
  );
};
